import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { api } from 'api';
import { user } from 'services';
import { TableExt, TableInfo, themes, GridBox, GridColumnsSetup } from 'libs/ui';
import { useGridColumns } from 'libs/hooks';
import { getTableParams } from './grid.params';
import BenefitForm from './forms/benefit-type-form';
import ImportForm from './forms/import-form';

export const BenefitTypeGrid = (props) => {
  const { count, entries, className, theme, refresh } = props;

  const [showForm, setShowForm] = useState('');
  const [showImport, setShowImport] = useState(false);
  const [row, setRow] = useState(null);

  const { t } = useTranslation();

  // actions
  const addItemAction = () => {
    setRow({});
    setShowForm('addForm');
  };

  const importAction = () => {
    setShowImport(true);
  };

  const closeImport = () => {
    setShowImport(false);
  };

  const editItemAction = (row) => {
    setRow(row);
    setShowForm('editForm');
  };

  /**
   * close form
   * @returns
   */
  const closeForm = () => {
    setRow(null);
    setShowForm('');
  };

  // actions
  const actions = [];
  const rightAdd = user.haveRight('benefit_types_check.add');
  const rightEdit = user.haveRight('benefit_types_check.update');
  const rightImport = user.haveRight('benefit_types.import_from_csv');

  if (rightEdit) {
    actions.push({
      getTitle: (row) => (row.status === 'active' ? 'Заблокировать' : 'Активировать'),
      action: async (row) => {
        await api.call('benefit_types.change_status', { id: row.id, status: row.status === 'active' ? 'blocked' : 'active' });
        refresh(true);
      },
    });
  }

  // top actions
  const topActions = [];
  if (rightAdd) {
    topActions.push({ title: t('buttons.Добавить'), icon: 'fa-plus', theme: themes.blue, action: addItemAction });
  }
  if (rightImport) {
    topActions.push({ title: t('buttons.Импорт'), icon: 'fa-upload', theme: themes.gray, action: importAction });
  }

  const tableParams = useMemo(() => getTableParams(t), [t]);
  const { getFields, fields: staticFields, ...restTableParams } = tableParams;
  const defaultFields = useMemo(() => (getFields ? getFields(props) : staticFields), [getFields, staticFields, props]);
  const { fields, columns, toggleColumn, reorderColumns, resetColumns } = useGridColumns('benefit-type', defaultFields);
  topActions.push({ cmp: <GridColumnsSetup key="columns-setup" columns={columns} onToggle={toggleColumn} onReorder={reorderColumns} onReset={resetColumns} /> });
  
  const items = Object.keys(entries).map((key) => entries[key]);
  const initial =
    showForm === 'addForm' || !row
      ? {}
      : {
          id: row.id,
          name: row.name,
          status: row.status,
          fn: row.data.fn,
          min_amount: Math.round(row.data?.min_amount / 100),
          amount: Math.round(row.data.amount / 100),
        };

  return (
    <GridBox>
      <TableInfo theme={theme} count={count} actions={topActions} />

      <TableExt
        theme={theme}
        title={t('sections.Скидки')}
        rows={{ count, items }}
        actions={actions}
        className={className}
        refresh={props.refresh}
        clientId={props.clientId}
        onRowClick={rightEdit ? editItemAction : undefined}
        {...restTableParams}
        fields={fields}
      />

      {showForm && <BenefitForm type={showForm} close={closeForm} refresh={props.refresh} initialValues={initial} />}

      {showImport && <ImportForm close={closeImport} />}
    </GridBox>
  );
};
